import { render, staticRenderFns } from "./BringFrontIcon.vue?vue&type=template&id=3de4dda4&"
import script from "./BringFrontIcon.vue?vue&type=script&lang=js&"
export * from "./BringFrontIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports